import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import routeTable from '../../utility/routeTable';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./cms-pages/cms-pages.module').then((m) => m.CmsPagesModule),
  },
  {
    path: routeTable.public.blogList,
    loadChildren: () => import('./blog/blog.module').then((m) => m.BlogModule),
  },
  {
    path: routeTable.public.contactUs,
    loadChildren: () =>
      import('./contact/contact.module').then((m) => m.ContactModule),
  },
  {
    path: routeTable.public.enquire,
    loadChildren: () =>
      import('./contact/contact.module').then((m) => m.ContactModule),
  },
  {
    path: routeTable.public.team,
    loadChildren: () => import('./team/team.module').then((m) => m.TeamModule),
  },
  {
    path: routeTable.public.searchLotCatalog,
    loadChildren: () =>
      import('./search-lot-catalog/search-lot-catalog.module').then(
        (m) => m.SearchLotCatalogModule
      ),
  },
  {
    path: routeTable.public.depositForm,
    loadChildren: () =>
      import('./payment-form/payment-form.module').then(
        (m) => m.PaymentFormModule
      ),
  },
  {
    path: routeTable.public.userPaymentForm,
    loadChildren: () =>
      import('./user-payment-form/user-payment-form.module').then(
        (m) => m.UserPaymentFormModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./auction/auction.module').then((m) => m.AuctionModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotLoggedInRoutingModule {}
